export default require('../otherChains/vizingTestnet').default.rpcUrls.default.http[0]